import {
  FormControl,
  FormHelperText,
  Grid,
  MenuItem,
  Select,
  styled,
  Typography,
} from "@mui/material";
import React from "react";

const DescGrid = styled(Grid)(({ theme }) => ({
  padding: "1%",
}));

const TitleGrid = styled(Grid)(({ theme }) => ({
  paddingLeft: "10%",
}));

const InputWidth = styled(FormControl)(({ theme }) => ({
  width: "80%",
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

type Props = {
  title: string;
  value: any[];
  selection: { value: string; text: string }[];
  handleEdit: (e: any) => void;
  helperText?: string;
  helperTextColor?: string;
};

export default function InputMultipleSelect({
  title,
  value,
  selection,
  handleEdit,
  helperText,
  helperTextColor = "error",
}: Props) {
  return (
    <Grid container justifyContent="center">
      <DescGrid container justifyContent="center">
        <TitleGrid item xs={12}>
          <Typography variant="h6" color="black">
            {title}
          </Typography>
        </TitleGrid>
        <Grid container justifyContent="center" item xs={12}>
          <InputWidth>
            <Select
              labelId="multiple-checkbox-label"
              id="multiple-checkbox"
              multiple
              value={value}
              onChange={handleEdit}
              MenuProps={MenuProps}
            >
              {selection.map((select, key) => (
                <MenuItem key={key} value={select.value}>
                  {select.text}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>
              <Typography color={helperTextColor} sx={{ fontSize: "0.75rem" }}>
                {helperText}
              </Typography>
            </FormHelperText>
          </InputWidth>
        </Grid>
      </DescGrid>
    </Grid>
  );
}
